import { render, staticRenderFns } from "./BrbCheckbox.vue?vue&type=template&id=9c1b29f2&scoped=true&"
import script from "./BrbCheckbox.vue?vue&type=script&lang=js&"
export * from "./BrbCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BrbCheckbox.vue?vue&type=style&index=0&id=9c1b29f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1b29f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c1b29f2')) {
      api.createRecord('9c1b29f2', component.options)
    } else {
      api.reload('9c1b29f2', component.options)
    }
    module.hot.accept("./BrbCheckbox.vue?vue&type=template&id=9c1b29f2&scoped=true&", function () {
      api.rerender('9c1b29f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbCheckbox.vue"
export default component.exports